import { render, staticRenderFns } from "./compliance.vue?vue&type=template&id=cb31d4ba&"
import script from "./compliance.vue?vue&type=script&lang=ts&"
export * from "./compliance.vue?vue&type=script&lang=ts&"
import style0 from "./compliance.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports